var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uC8FC\\uCC28\\uAD00\\uC81C_\\uAC15\\uC81C\\uD3D0\\uC1C4",
    transform: "translate(-2618 11317)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8621",
    "data-name": "\\uC0AC\\uAC01\\uD615 8621",
    width: 32,
    height: 32,
    rx: 2,
    transform: "translate(2618 -11317)",
    fill: "rgba(45,52,72,0.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8625",
    "data-name": "\\uC0AC\\uAC01\\uD615 8625",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(2622 -11313)",
    fill: "#2d3448"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_15323",
    "data-name": "\\uADF8\\uB8F9 15323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6206",
    "data-name": "\\uD328\\uC2A4 6206",
    d: "M18.028,5.551H15.663L15.52,3.884a2.442,2.442,0,0,0-2.44-2.44H4.947a2.442,2.442,0,0,0-2.44,2.44L2.435,5.551H0V6.933l2.2.154A1.863,1.863,0,0,0,1.369,8.6v2.764A1.9,1.9,0,0,0,2.394,13v1.859c0,.629.731,1.138,1.632,1.138s1.631-.51,1.631-1.138V13.317h6.434v1.544c0,.629.73,1.138,1.631,1.138s1.631-.51,1.631-1.138V13.136a1.952,1.952,0,0,0,1.305-1.773V8.6a1.864,1.864,0,0,0-.827-1.513l2.2-.154ZM2.454,7.12l0-.034C2.467,7.1,2.472,7.108,2.454,7.12ZM3.483,3.884A1.465,1.465,0,0,1,4.946,2.42h8.133a1.466,1.466,0,0,1,1.465,1.464V6.655c-.042,0-.082-.006-.125-.006H3.606c-.042,0-.083,0-.123.006ZM5.8,9.834A1.379,1.379,0,1,1,4.423,8.456,1.379,1.379,0,0,1,5.8,9.834Zm9.2,0a1.379,1.379,0,1,1-1.379-1.379A1.379,1.379,0,0,1,15,9.834Z",
    transform: "translate(2625 -11309.444)",
    fill: "#f77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_15327",
    "data-name": "\\uADF8\\uB8F9 15327"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1127",
    "data-name": "\\uD0C0\\uC6D0 1127",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(2636 -11300)",
    fill: "#2d3448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6205",
    "data-name": "\\uD328\\uC2A4 6205",
    d: "M5.98,1.024a3.5,3.5,0,1,0,0,4.952A3.505,3.505,0,0,0,5.98,1.024Zm-4.4.548a2.731,2.731,0,0,1,3.316-.419L1.158,4.888A2.729,2.729,0,0,1,1.576,1.572ZM5.431,5.427a2.731,2.731,0,0,1-3.294.432L5.863,2.134A2.729,2.729,0,0,1,5.431,5.427Z",
    transform: "translate(2636.996 -11299)",
    fill: "#f77"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingOff);
export default __webpack_public_path__ + "static/media/parking_off.d3e9297f833f374c246ffad513102820.svg";
export { ForwardRef as ReactComponent };